import {CDA_TAX_PERCENT} from 'constants/cdaConstants'

export const getTotalPriceWithTax = (price: number) => {
  const totalPriceWithTax = price ? (price + (price * CDA_TAX_PERCENT) / 100).toFixed(2) : ''
  return totalPriceWithTax
}
